import { theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import { PermitElementRow } from 'components/services/PermitElementRow';
import React from 'react';
import { AccessPermitPoolingGroupCombinedInfo } from 'types/generatedSchemaTypes';

export interface PoolingGroupRowProps {
  group: AccessPermitPoolingGroupCombinedInfo;
  index: number;
  onPress: () => void;
  t: (key: string, options?: any) => string;
}

export const PoolingGroupRow: React.FC<PoolingGroupRowProps> = ({
  group,
  index,
  onPress,
  t,
}) => {
  if (!group) return null;

  return (
    <PermitElementRow
      key={`pooling-group-${group.uid}`}
      label={group?.salesLocationName || group?.parkingZoneName || '-'}
      sublabel={group?.pmcName || undefined}
      detail={
        group.capacityHidden
          ? t('permit.access.no_spot_data')
          : t('permit.access.spot', { count: group.freePoolingSpots ?? 0 })
      }
      detailColor={
        group.capacityHidden ? theme.colors.gray300 : theme.colors.black
      }
      icon={<Icon color={theme.colors.black} name="Chevron_Right" />}
      withTopBorder={index !== 0}
      borderColor={'#0A0A0A0A'}
      labelColor={theme.colors.black}
      onPress={onPress}
    />
  );
};
